import React from "react";

import StdButton from './stdbutton.jsx';

class UploadForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isDone: false,
            isSubmitted: false,
            data: null
        };
        this.uploadFormRef = React.createRef();
        this.setState = this.setState.bind(this);
        this.doUpload = this.doUpload.bind(this);
    }

    doUpload(event) {
        event.preventDefault();
        const data = new FormData(this.uploadFormRef.current);
        this.setState({isSubmitted: true});
        doPostForm("/web/upload", data, (response) => {
            this.setState({
                ...response,
                isSubmitted: false,
                isDone: true
            })
        });
    }

    render() {
        return (
            <div style={{background: '#ffffff', border: '2px solid #dfdfdf', padding: 20}}>
                <div>
                    <h2>Upload Tower Data</h2>
                </div>
                {this.renderBody()}
            </div>
        );
    }

    renderBody() {
        if (this.state.isDone) {
            if (this.state.error) {
                return (
                    <div>Error: {this.state.error.message}</div>
                )
            } else if (this.state.data.exception) {
                return (
                    <div>
                        <div>Error: {this.state.data.exception}</div>
                        <br/>
                        <details>
                            <summary>Information for developers</summary>
                            <pre>
                                <code>{this.state.data.stackTrace}</code>
                            </pre>
                        </details>
                    </div>
                )
            } else {
                return (
                    <ul>
                        <li>New records added: {this.state.data.recordsAdded} </li>
                        <li>Existing records updated: {this.state.data.recordsUpdated} </li>
                        <li>Skipped records: {this.state.data.recordsSkipped} </li>
                    </ul>
                )
            }
        } else if (this.state.isSubmitted) {
            return (
                <div className="text-center">
                    <div className="spinner-border m-5"/>
                </div>
            )

        } else {
            return (
                <form ref={this.uploadFormRef}>

                    <div className="form-group form-group-sm">
                        <label className=" control-label">Towers CSV </label>
                        <a href={location.protocol + '//' + location.host + '/towers/Tower.csv'}> (example)</a>
                        <div className="">
                            <input type="file" name="file"/>
                        </div>
                    </div>

                    <div className="">
                        <div className="">
                            <StdButton onClick={this.doUpload} label="Send"/>
                        </div>
                    </div>

                </form>
            )
        }
    }


}

export default UploadForm;